import locationImage from './mini-pelle-terramc24-asf-terrassement-propriete.webp';

export const Location = () => {
    return (
        <section id="location" className="hero bg-secondary py-8">
            <div className="hero-content flex-col lg:flex-row-reverse items-center">
                <img
                    src={locationImage}
                    alt="mini-pelle orange modele terra mc34 asf terrassement propriete"
                    className="rounded-lg shadow-2xl"
                    width={450}
                />
                <div className='py-6'>
                    <h1 className="text-5xl font-bold text-white mb-3">Location de mini-pelle Terra MS24</h1>
                    <p className="text-white py-6">
                        Vous avez un projet de travaux et vous avez besoin d'une mini-pelle ?
                    </p>
                    <p className='text-white mb-3'>Nous proposons un service de location de mini-pelle pour vous aider dans vos travaux.</p>
                    <p className='text-white mb-3'>N'hésitez pas à nous contacter si vous avez des questions à propos de la location.</p>
                    <button contact className="btn btn-accent text-white text-center"><a href='/contact'>Nous contacter</a></button>
                </div>
            </div>
        </section>
    );
};

export default Location;